/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICheckoutPaymentInstrumentViewProps, ICheckoutPaymentOverlayModal } from '@msdyn365-commerce-modules/checkout';
import { ICheckoutPaymentInstrumentProps as ICheckoutPaymentInstrumentExtensionProps } from '../definition-extensions/checkout-payment-instrument.ext.props.autogenerated';

import { PaymentContext, IPaymentTenderType } from '../../../modules/payment-container/context/payment-context';

const OverlayModal: React.FC<ICheckoutPaymentOverlayModal> = ({ modal }) => {
    return <Node {...modal} />;
};

const CheckoutPaymentInstrumentView: React.FC<ICheckoutPaymentInstrumentViewProps & ICheckoutPaymentInstrumentExtensionProps<{}>> = ({
    checkoutPaymentInstrument,
    className,
    id,
    waiting,
    alert,
    paymentInformation,
    addPaymentForm,
    overlayModal,
    config: { tenderType },
    ...restProps
}) => {
    const paymentContext = React.useContext(PaymentContext);
    const paymentTenderTypes: IPaymentTenderType[] = [];

    React.useEffect(() => {
        tenderType?.map(tt => {
            paymentTenderTypes.push({
                tenderTypeId: tt.tenderId,
                tenderName: tt.tenderName,
                showOnNormalPartsCheckout: tt.showOnNormalPartsCheckout ?? true,
                showOnInvoiceCheckout: tt.showOnInvoiceCheckout ?? true
            });
        });
        paymentContext.registerPaymentMethod(id, paymentTenderTypes);
    }, []);

    return (
        <Module {...checkoutPaymentInstrument}>
            {waiting}
            {alert}
            {paymentInformation}
            {addPaymentForm}
            {overlayModal && <OverlayModal {...overlayModal} />}
        </Module>
    );
};

export default CheckoutPaymentInstrumentView;
